/**
 * Roles `LIC_*` do client `dashboard-back` no token (as mesmas do back, em
 * `licenciamento-permissions.ts`). Sem `admin`: preso ao próprio cliente. Com `admin`: equipe da Clever,
 * escolhe o cliente.
 *
 * O front só esconde o que a role não permite; quem decide é o back.
 */
export const LIC_ROLES = {
  read: 'LIC_read',
  ativar: 'LIC_ativar',
  desativar: 'LIC_desativar',
  robotConfig: 'LIC_robot_config',
  admin: {
    read: 'LIC_admin_read',
    ativar: 'LIC_admin_ativar',
    desativar: 'LIC_admin_desativar',
    licenca: 'LIC_admin_licenca',
    nivel: 'LIC_admin_nivel',
    chaveGeral: 'LIC_admin_chaveGeral',
    aprovar: 'LIC_admin_aprovar',
  },
};

/** O que o usuário pode fazer em cada escopo, a partir das roles do token. */
export const licPermissoes = (roles = []) => {
  const tem = (role) => roles.includes(role);
  const cliente = {
    read: tem(LIC_ROLES.read),
    ativar: tem(LIC_ROLES.ativar),
    desativar: tem(LIC_ROLES.desativar),
    // Edição da configuração das instalações Robot PP do próprio cliente. Não dá licença nem nível.
    robotConfig: tem(LIC_ROLES.robotConfig),
  };
  const admin = {
    read: tem(LIC_ROLES.admin.read),
    ativar: tem(LIC_ROLES.admin.ativar),
    desativar: tem(LIC_ROLES.admin.desativar),
    licenca: tem(LIC_ROLES.admin.licenca),
    nivel: tem(LIC_ROLES.admin.nivel),
    chaveGeral: tem(LIC_ROLES.admin.chaveGeral),
    aprovar: tem(LIC_ROLES.admin.aprovar),
    // A equipe edita instalações com `LIC_admin_ativar` (contrato do Robot PP), não com `LIC_admin_licenca`.
    robotConfig: tem(LIC_ROLES.admin.ativar),
  };
  return {
    cliente: { ...cliente, algum: cliente.read || cliente.ativar || cliente.robotConfig },
    admin: { ...admin, algum: admin.read || admin.ativar },
  };
};

/** Permissões do escopo de uma tela (`admin` = rotas da equipe). */
export const permissoesDoEscopo = (roles, admin) => licPermissoes(roles)[admin ? 'admin' : 'cliente'];
